import { render } from "./RpmTable.vue?vue&type=template&id=60f4ca4b"
import script from "./RpmTable.vue?vue&type=script&lang=js"
export * from "./RpmTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__